import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, computed } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import { useScroll } from '@vueuse/core';

interface Props {
  menu: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    menu: null
  },
  setup(__props: any) {



const { $config } = useContext();

const { refLink } = $config;

const headerBottom = ref();
const languageSwitcher = ref();
const isTopBlockShown = ref(true);
const modalSearch = ref(null);
let scrollElement = null;
if (process.client) {
  scrollElement = window;
}
const { y, isScrolling, directions } = useScroll(scrollElement);
watch(
  () => directions.bottom,
  (newValue) => {
    if (newValue === true) isTopBlockShown.value = false;
  },
);
watch(
  () => directions.top,
  (newValue) => {
    if (newValue === true) isTopBlockShown.value = true;
  },
);

watch(isScrolling, (newValue) => {
  if (newValue === true) {
    languageSwitcher.value.close();
  }
});

const isScrollTop = computed(() => y.value === 0);

return { __sfc: true,$config, refLink, headerBottom, languageSwitcher, isTopBlockShown, modalSearch, scrollElement, y, isScrolling, directions, isScrollTop }
}

})